import { discountValue, productDiscount } from "@/helpers/discount";
import { fullPrice } from "@/helpers/product";

// calcula o valor do desconto da compra
const orderDiscount = (context, order) => {
  if (!order.discount && !order.coupon && !order.loyalty) return 0;

  const offer = order.coupon ? order.coupon : order.loyalty;

  return discountValue(context, subtotal(context, order), offer);
};

// calcula o preço da compra, levando em conta a taxa de entrega
const total = (context, order) => {
  let result = subtotal(context, order);

  if (order.deliveryFee) result += order.deliveryFee;

  return result;
};

// calcula o subtotal, levando em conta todos os itens da compra
const subtotal = (context, order) => {
  let result = 0;

  order.items.forEach((item) => {
    result += item.quantity * item.originalPrice;

    item.complements.forEach((comp) => {
      result += comp.quantity * comp.price * item.quantity;
    });

    if (item.relatedOffer && item.relatedOffer.offerId) {
      const offers = productDiscount(order.offers, item.relatedOffer.offerId);

      offers.forEach((offer) => {
        result -=
          discountValue(context, fullPrice(item), offer) * item.quantity;
      });
    }
  });

  return result;
};

export { subtotal, orderDiscount, total };
